import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ScreenSizeService, ViewMode } from '../../../../services/screen-size/screen-size.service';

export class InhaltConfig {
  public static readonly COLLAPSE_MAX_HEIGHT = 172;
  public static readonly MOBILE_COLLAPSE_MAX_HEIGHT = 72;

  // Ab dieser Zeichenzahl im reinen Text bekommt ein Textblock den Aufklapp-Schalter
  public static readonly COLLAPSE_MIN_LENGTH = 120;

  public static getCollapseMaxHeight$(): Observable<number> {
    return inject(ScreenSizeService)
      .rangeFrom$(ViewMode.TABLET)
      .pipe(
        map((phablet) =>
          phablet ? InhaltConfig.COLLAPSE_MAX_HEIGHT : InhaltConfig.MOBILE_COLLAPSE_MAX_HEIGHT
        )
      );
  }
}
